import * as React from 'react';
import InputBase from '@mui/material/InputBase';
import styled from "@emotion/styled";
import { alpha } from '@mui/material/styles';
import variables from './../../../css/theme.module.scss';

import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import InputMask from 'react-input-mask';
import MUISelect from "@mui/material/Select";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";

import {ReactComponent as CheckBoxIcon} from "../../../icons/Checkbox.svg";
import {ReactComponent as CheckedBoxIcon} from "../../../icons/Checkbox_checked.svg";
import {Checkbox, InputAdornment} from "@mui/material";

export const CheckBoxSbb = (props) => {
    return <Checkbox {...props}
                     sx={{ '& .MuiSvgIcon-root': { fontSize: 28 },
                         color: "#E3E4E6",
                     }}
                     checkedIcon={<CheckedBoxIcon viewBox="0 0 28 28"/>}
                     icon={<CheckBoxIcon viewBox="0 0 28 28"/>}
    />
}

export const FormControlLabelSbb = styled(FormControlLabel)({
    "& .MuiFormControlLabel-label": {
        fontFamily: variables.AvenirHeavy,
        fontSize: '14px',
        fontWeight: '900',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        whiteSpace: 'pre-wrap'
    },
})

export const Select = styled(MUISelect)({
    fontFamily: variables.AvenirBook,
    '&.MuiInputBase-root .MuiOutlinedInput-notchedOutline': {
        borderColor: "#E3E4E6"
    },
    '&.MuiInputBase-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#E3E4E6'
    },
    '& .MuiSelect-select': {
        borderRadius: '4px',
        padding: '13px 14px',
        position: 'relative',
        fontFamily: variables.AvenirLight,
        fontSize: '15px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'left',
        color: variables.textDefault,
    },
    'fieldset legend': {
        fontSize: '0.85em'
    }
});

export const SbbInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(3),
    },
    '&.margin-top-0':{
      marginTop: 0
    },
    '&.Mui-disabled':{
        '& .MuiInputAdornment-root': {
            '& p': {
                color: 'black!important'
            }
        }
    },
    '&.Mui-error': {
        '& .MuiInputBase-input': {
            color: '#ff1744',
            border: 'solid 1px #ff1744',
        }
    },
    '& .MuiInputBase-input': {
        borderRadius: '4px',
        border: 'solid 1px ' + variables.lightGray,
        padding: '12.28px',
        position: 'relative',
        fontFamily: variables.AvenirBook,
        fontSize: '16px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'left',
        color: "#353D50",
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        '&::-webkit-calendar-picker-indicator': {
            color: "#353D50",
        },
            '&:focus': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
        '&.MuiInputBase-inputSizeSmall':{
            padding: '6px 14px',
        }
    },
    '&.dark':{
        '& .MuiInputBase-input': {
            border: 'solid 1px white',
            color: 'white',
            backgroundColor: "black",
            '&::-webkit-calendar-picker-indicator':{
                filter: 'invert(1)'
            },
        },
        '&.borderless .MuiInputBase-input':{
            border: 'unset'
        }
    },
    '&.blueBack':{
        '& .MuiInputBase-input': {
            border: 'solid 0.5px rgba(255,255,255,0.25)',
            color: 'white',
            backgroundColor: "none",
        },
        '&.borderless .MuiInputBase-input':{
            border: 'unset'
        }
    },
    '&.white':{
        '& .MuiInputBase-input': {
            border: 'solid 1px white',
            color: "black",
            backgroundColor: '#fff',
        },
        '&.borderless .MuiInputBase-input':{
            border: 'unset'
        }
    },
}));

export const SbbInputAdornment = styled(InputAdornment)(({ theme }) => ({
    '&.MuiInputAdornment-root': {
        '& p': {
            fontFamily: variables.AvenirLight,
            color: 'black',
            fontSize: '16px',
            lineHeight: '24px'
        }
    }
}));


export const SbbLabel = styled(InputLabel)(({ theme }) => ({
    margin: '0 -15px',
    fontFamily: variables.AvenirHeavy,
    fontSize: '14px',
    fontWeight: '900',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '24px',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: "black",
    left: theme.spacing(2),
    '&.dark':{
        color: 'white'
    },
    '&.yellow':{
        color: variables.secondary
    },
    '&.MuiInputLabel-shrink':{
        transform: 'translate(0px, -1.5px) scale(1)'
    },
    '& .active':{
        transform: 'translate(0px, -20px) scale(1)'
    },
    '&.Mui-error':{
        color: '#ff1744'
    },
}));

export const SbbFormControl = styled(FormControl)(({ theme }) => ({
    '& .info-message': {
        fontFamily: variables.AvenirBook,
        fontSize: '11px',
        fontWeight: '900',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'right',
        margin: '2px 0 0 15px',
        color: "black"
    },
    '& .error-message': {
        fontFamily: variables.Avenir,
        fontSize: '11px',
        fontWeight: '900',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'left',
        margin: '2px 0 0 15px'
    },
    '&.has-error':{
        '& .MuiInputBase-input': {
            color: theme.palette.error.main,
            border: 'solid 1px red',
            '&:focus': {
                boxShadow: `${alpha(theme.palette.error.main, 0.25)} 0 0 0 0.2rem`,
                borderColor: theme.palette.error.main,
            },
        },
        '& .MuiInputLabel-root':{
            color: theme.palette.error.main,
        },
        '& .error-message': {
            color: theme.palette.error.main,
        }
    },
}));

export const SbbFormInput = ({label, name, placeholder, type, defaultValue,
                                 readOnly, required, multiline, register, errors,
                                 className, customValidate, onChange, addProps,
                                 helperInfoText, helperText, variant, formClasses=''}) => {
    const generateInput = () => {
        switch(type){
            case 'phone':
                return <InputMask
                            maskPlaceholder="(999) 999-9999"
                            placeholder={placeholder}
                            id={name}
                            mask="(999) 999-9999"
                            value={defaultValue}
                            alwaysShowMask
                            disabled={false}
                            className={className}
                            onChange={onChange}>
                            {() => <SbbInput />}
                        </InputMask>;
            case 'onChange':
                if(customValidate){
                    return <SbbInput placeholder={placeholder}
                                     id={name}
                                     name={name}
                                     type={type}
                                     defaultValue={defaultValue}
                                     multiline={multiline}
                                     className={className}
                                     onChange={onChange}
                                     {...addProps}
                                     {...register(name, { ...customValidate['validation'], required: required, readonly: readOnly })}
                    />
                }else{
                    return <SbbInput placeholder={placeholder}
                                     id={name}
                                     name={name}
                                     type={type}
                                     defaultValue={defaultValue}
                                     multiline={multiline}
                                     className={className}
                                     onChange={onChange}
                                     {...addProps}
                                     {...register(name, {required: required, readonly: readOnly })}
                    />
                }
            default:
                if(customValidate){
                    return <SbbInput placeholder={placeholder}
                                     id={name}
                                     name={name}
                                     type={type}
                                     defaultValue={defaultValue}
                                     multiline={multiline}
                                     className={className}
                                     {...addProps}
                                     {...register(name, { ...customValidate['validation'], required: required, readonly: readOnly })}
                    />
                }else{
                    return <SbbInput placeholder={placeholder}
                                     id={name}
                                     name={name}
                                     type={type}
                                     defaultValue={defaultValue}
                                     multiline={multiline}
                                     className={className}
                                     {...addProps}
                                     {...register(name, {required: required, readonly: readOnly })}
                    />
                }
        }
    };
    const NOT_VALID_MSG = '*Input is not valid';
    return (
        <SbbFormControl fullWidth variant="standard" className={formClasses + ' ' + (errors[name] ? 'has-error' : '')} >
            <SbbLabel shrink={true} htmlFor={name} required={required} className={className}>
                {label}
            </SbbLabel>
            {generateInput()}
            {helperText && <span className="error-message">{helperText}</span>}
            {helperInfoText && <span className="info-message">{helperInfoText}</span>}
            {errors[name] && errors[name]['type'] === 'required' && <span className="error-message">*This is required</span>}
            {errors[name] && errors[name]['type'] === 'validate' && <span className="error-message">{customValidate['msg'] ? customValidate['msg'] : NOT_VALID_MSG}</span>}
            {errors[name] && errors[name]['type'] === 'pattern' && <span className="error-message">{customValidate['pattern_msg'] ? customValidate['pattern_msg'] : NOT_VALID_MSG}</span>}
            {errors[name] && errors[name]['type'] === 'minLength' && <span className="error-message">{customValidate['minLengthMsg'] ? customValidate['minLengthMsg'] : NOT_VALID_MSG}</span>}
            {errors[name] && errors[name]['type'] === 'maxLength' && <span className="error-message">{customValidate['maxLengthMsg'] ? customValidate['maxLengthMsg'] : NOT_VALID_MSG}</span>}
        </SbbFormControl>)
};
